import { makeAutoObservable } from 'mobx'
import { uiStore } from 'shared/store/uiStore'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { SettingsRoutes } from 'entities/ExportRouters'
import { MembersRoutes } from 'pages/settings/pages/members'

export class ManageInfoStore {
  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)

    this.init()
  }

  init = async () => {
    await Promise.all([
      this._entities.billingStore.fetchBillingComplianceInfo(),
      this._entities.shortLinkStore.loadCustomDomain(),
    ])
  }

  get numbersUsed() {
    return this._entities.subscriptionStore.numbers?.used ?? 0
  }

  get numbersTotal() {
    return this._entities.subscriptionStore.numbers?.total ?? 0
  }

  get seatsUsed() {
    return this._entities.subscriptionStore.seatsUsed
  }

  get seatsTotal() {
    return this._entities.subscriptionStore.seatsTotal
  }

  get addOnsTotal() {
    return 3
  }

  get addOnsActive() {
    const isPhoneCheckrActive = this._entities.organizationStore.isPhoneCheckerEnabled
    const isTrustedCallingActive =
      this._entities.billingStore.billingComplianceInfo?.subscribed ?? false
    const isBrandedUrlShortenerActive = this._entities.shortLinkStore.isActiveCustomDomain

    return [isPhoneCheckrActive, isTrustedCallingActive, isBrandedUrlShortenerActive].filter(
      Boolean
    ).length
  }

  onManageNumbersClick = () => {
    uiStore.changeRoute({
      path: `/${SettingsRoutes.root}/${SettingsRoutes.numbers}`,
    })
  }

  onManageSeatsClick = () => {
    uiStore.changeRoute({
      path: `/${SettingsRoutes.root}/${MembersRoutes.root}`,
    })
  }

  onManageAddOnsClick = () => {
    uiStore.changeRoute({
      path: `/${SettingsRoutes.root}/${SettingsRoutes.addOns}`,
    })
  }
}
